// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__2JX13","Open":"SideDrawer_Open__3X5C_","Close":"SideDrawer_Close__1gKnD","Logo":"SideDrawer_Logo__1Zor8"};